import React, { useState } from 'react';
import { Button, Form, Modal, TextArea } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { SemanticSIZES } from 'semantic-ui-react/dist/commonjs/generic';

type Props = {
  basic?: boolean;
  size?: SemanticSIZES;
  buttonTitle?: string;
  rejectFileSet: (reason: string) => void;
};

function RejectionModal({ basic, size, buttonTitle, rejectFileSet }: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const onSubmit = () => {
    setIsSubmitting(true);
    setOpen(false);
    rejectFileSet(reason);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      as={Form}
      onSubmit={onSubmit}
      closeIcon
      onClose={onClose}
      onOpen={() => {
        setIsSubmitting(false);
        setOpen(true);
        setReason('');
      }}
      open={open}
      trigger={
        <Button
          content={buttonTitle || t('upload.reject')}
          icon="close"
          labelPosition="left"
          negative
          basic={basic}
          size={size}
        />
      }
    >
      <Modal.Header>{t('upload.rejection.modal.title')}</Modal.Header>
      <Modal.Content>
        <Form.Field>
          <TextArea
            placeholder={t('upload.rejection.modal.placeholder')}
            value={reason}
            onChange={value => setReason(value.target.value)}
            autoFocus
          />
        </Form.Field>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose}>{t('button.cancel')}</Button>
        <Button
          type="submit"
          content={t('button.save')}
          labelPosition="right"
          icon="checkmark"
          positive
          disabled={reason.length < 3 || isSubmitting}
        />
      </Modal.Actions>
    </Modal>
  );
}

RejectionModal.defaultProps = {
  basic: false,
  size: 'medium',
  buttonTitle: undefined,
};

export default RejectionModal;
